import React, { useState } from "react";

import * as styles from "/src/components/About/AboutVision.module.css";
import { FaGlobe } from "@react-icons/all-files/fa/FaGlobe";

const AboutVision = (props) => {
  const [primaryActive, setPrimaryActive] = useState(true);
  const toggleToSecondary = () => setPrimaryActive(false);
  const toggleToPrimary = () => setPrimaryActive(true);
  const data = {
    mg_impact: {
      vision: props.mgoriumImpactOurVisionText,
      impact: props.mgoriumImpactOurImpactText,
    },
    magorium: {
      vision: props.mgoriumOurVisionText,
      impact: props.mgoriumOurImpactText,
    },
  };

  return (
    <div className={styles.aboutVision}>
      <div className={styles.aboutButtonsContainer}>
        <button
          className={primaryActive ? styles.active : null}
          onClick={toggleToPrimary}
        >
          Mgorium Impact
        </button>
        <button
          className={!primaryActive ? styles.active : null}
          onClick={toggleToSecondary}
        >
          Mgorium
        </button>
      </div>

      <div className={styles.aboutInfoContainer}>
        <h1>Our Impact</h1>
        <p>{primaryActive ? data.mg_impact.impact : data.magorium.impact}</p>
        <h1>Our Vision</h1>
        <p>{primaryActive ? data.mg_impact.vision : data.magorium.vision}</p>
        {!primaryActive && (
          <div className={styles.websiteButton}>
            <FaGlobe color="white" />
            <a href="https://www.mgrium.com/">www.mgrium.com</a>
          </div>
        )}
      </div>
    </div>
  );
};

export default AboutVision;
